import axios from '@/libs/api.request'
// 获取全部项目的修改进度
export const getMaterialProject = data => {
  return axios.request({
    url: '/material/query/progress/project',
    data,
    method: 'POST'
  })
}
// 获取单个项目的修改进度
export const getMaterialSingleProject = data => {
  return axios.request({
    url: '/material/query/single/progress/project',
    data,
    method: 'POST'
  })
}
// 上传文书
export const subUploadEssay = data => {
  return axios.request({
    url: '/material/upload/essay',
    data,
    method: 'POST'
  })
}
// cv list
export const getMeterialCVList = data => {
  return axios.request({
    url: '/material/query/progress/cv',
    data,
    method: 'POST'
  })
}
// rl list
export const getMeterialRLList = data => {
  return axios.request({
    url: '/material/query/progress/rl',
    data,
    method: 'POST'
  })
}
// 获取单独的cv
export const getMeterialSingleCVList = data => {
  return axios.request({
    url: '/material/query/single/progress/cv',
    data,
    method: 'POST'
  })
}
//  获取单独的rl
export const getMeterialSingleRLList = data => {
  return axios.request({
    url: '/material/query/single/progress/rl',
    data,
    method: 'POST'
  })
}
// 上传cv
export const subMenterialUploadCV = data => {
  return axios.request({
    url: '/material/upload/cv',
    data,
    method: 'POST'
  })
}
// 上传rl
export const subMenterialUploadRL = data => {
  return axios.request({
    url: '/material/upload/rl',
    data,
    method: 'POST'
  })
}
// 查询ESSAY是否已经全部完成
export const getMaterialQueryModuleFinishProject = data => {
  return axios.request({
    url: '/material/query/module/finish/project',
    data,
    method: 'POST'
  })
}
// 查询CV是否已经全部完成
export const getMaterialQueryModuleFinishCv = data => {
  return axios.request({
    url: '/material/query/module/finish/cv',
    data,
    method: 'POST'
  })
}
// 查询RL是否已经全部完成
export const getMaterialQueryModuleFinishRl = data => {
  return axios.request({
    url: '/material/query/module/finish/rl',
    data,
    method: 'POST'
  })
}
